

export const bagsObj = [

];
